import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.pos.sales.menu');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-pos-sales-menu',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.pos.sales.menu/view.scss */
:host {
  display: block;
  height: 100%;
  overflow: hidden;
}

* {
  box-sizing: border-box;
}

.menu-mgmt-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--pos-bg);
  color: var(--pos-text);
  font-family: "Noto Sans KR", -apple-system, BlinkMacSystemFont, sans-serif;
}

.mgmt-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  background: var(--pos-panel);
  border-bottom: 1px solid var(--pos-border);
  flex-shrink: 0;
  box-shadow: var(--pos-shadow);
}
.mgmt-header .header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.mgmt-header .back-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid var(--pos-border);
  background: transparent;
  color: var(--pos-text-dim);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 150ms;
  padding: 0;
}
.mgmt-header .back-btn svg {
  width: 18px;
  height: 18px;
}
.mgmt-header .back-btn:hover {
  background: var(--pos-card);
  color: var(--pos-text);
}
.mgmt-header .header-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--pos-text);
}
.mgmt-header .header-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.search-box {
  position: relative;
  display: flex;
  align-items: center;
}
.search-box .search-icon {
  position: absolute;
  left: 10px;
  width: 16px;
  height: 16px;
  stroke: var(--pos-text-dim);
  pointer-events: none;
}
.search-box input {
  width: 240px;
  height: 36px;
  padding: 0 12px 0 34px;
  background: var(--pos-input-bg, #f0f2f5);
  border: 1px solid var(--pos-border);
  border-radius: 8px;
  color: var(--pos-text);
  font-size: 13px;
  outline: none;
}
.search-box input:focus {
  border-color: var(--pos-accent);
}
.search-box input::placeholder {
  color: var(--pos-text-dim);
}

.mgmt-body {
  flex: 1;
  display: flex;
  min-height: 0;
  overflow: hidden;
}

.mgmt-sidebar {
  width: 220px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--pos-border);
  background: var(--pos-panel);
}

.sidebar-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid var(--pos-border);
}
.sidebar-top .sidebar-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--pos-text);
}

.add-cat-toggle {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  border: 1px solid var(--pos-border);
  background: transparent;
  color: var(--pos-text-dim);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.add-cat-toggle:hover {
  background: var(--pos-accent);
  color: #fff;
  border-color: var(--pos-accent);
}

.cat-add-row {
  display: flex;
  gap: 6px;
  padding: 10px 12px;
  border-bottom: 1px solid var(--pos-border);
}
.cat-add-row input {
  flex: 1;
  height: 32px;
  padding: 0 10px;
  font-size: 12px;
  background: var(--pos-input-bg);
  border: 1px solid var(--pos-border);
  border-radius: 6px;
  color: var(--pos-text);
  outline: none;
}
.cat-add-row input:focus {
  border-color: var(--pos-accent);
}

.cat-add-btn {
  padding: 0 12px;
  border-radius: 6px;
  border: none;
  background: var(--pos-accent);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}
.cat-add-btn:hover {
  background: var(--pos-accent-hover, #2563eb);
}

.cat-list {
  flex: 1;
  overflow: auto;
  padding: 8px 0;
}

.cat-item {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 11px 16px;
  border: none;
  background: transparent;
  color: var(--pos-text);
  font-size: 13px;
  cursor: pointer;
  transition: all 100ms;
  text-align: left;
}
.cat-item:hover {
  background: var(--pos-hover, rgba(59, 130, 246, 0.06));
}
.cat-item.active {
  background: rgba(59, 130, 246, 0.08);
  color: var(--pos-accent);
  font-weight: 600;
  border-right: 3px solid var(--pos-accent);
}

.cat-label {
  flex: 1;
}

.cat-count {
  font-size: 11px;
  font-weight: 500;
  color: var(--pos-text-dim);
  background: var(--pos-bg);
  padding: 2px 8px;
  border-radius: 10px;
  min-width: 22px;
  text-align: center;
}

.cat-del {
  width: 44px;
  height: 44px;
  border-radius: 8px;
  border: none;
  background: transparent;
  color: var(--pos-text-dim);
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: -12px -8px -12px 0;
}
.cat-del:hover, .cat-del:active {
  color: var(--pos-red);
  background: rgba(239, 68, 68, 0.12);
}

.mgmt-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.mgmt-form-area {
  flex-shrink: 0;
  padding: 16px 24px;
  border-bottom: 1px solid var(--pos-border);
  background: var(--pos-panel);
}

.form-header {
  margin-bottom: 12px;
}
.form-header .form-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--pos-text);
}

.form-row {
  display: flex;
  gap: 12px;
  align-items: flex-end;
}

.form-field {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.form-field label {
  font-size: 11px;
  font-weight: 500;
  color: var(--pos-text-dim);
}
.form-field input, .form-field select {
  height: 38px;
  padding: 0 12px;
  font-size: 13px;
  background: var(--pos-input-bg, #f0f2f5);
  border: 1px solid var(--pos-border);
  border-radius: 8px;
  color: var(--pos-text);
  outline: none;
}
.form-field input:focus, .form-field select:focus {
  border-color: var(--pos-accent);
}
.form-field select {
  padding-right: 8px;
}

.form-actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
  padding-bottom: 1px;
}

.btn-save {
  height: 38px;
  padding: 0 20px;
  border-radius: 8px;
  border: none;
  background: var(--pos-accent);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}
.btn-save:hover {
  background: var(--pos-accent-hover, #2563eb);
}
.btn-save:active {
  transform: scale(0.97);
}

.btn-cancel {
  height: 38px;
  padding: 0 16px;
  border-radius: 8px;
  border: 1px solid var(--pos-border);
  background: transparent;
  color: var(--pos-text-dim);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
}
.btn-cancel:hover {
  background: var(--pos-card);
  color: var(--pos-text);
}

.mgmt-list-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.list-header {
  display: flex;
  align-items: center;
  padding: 10px 24px;
  border-bottom: 1px solid var(--pos-border);
  font-size: 11px;
  font-weight: 600;
  color: var(--pos-text-dim);
  background: var(--pos-table-header, #f0f2f5);
  flex-shrink: 0;
}

.list-body {
  flex: 1;
  overflow: auto;
}

.list-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: var(--pos-text-dim);
  font-size: 14px;
}

.list-item {
  display: flex;
  align-items: center;
  padding: 12px 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  transition: background 100ms;
}
.list-item:hover {
  background: var(--pos-hover, rgba(59, 130, 246, 0.04));
}
.list-item.is-editing {
  background: rgba(59, 130, 246, 0.06);
  border-left: 3px solid var(--pos-accent);
}

.col-name {
  flex: 2;
  font-size: 14px;
  font-weight: 500;
  color: var(--pos-text);
}

.col-price {
  flex: 1;
  font-size: 14px;
  color: var(--pos-text);
  text-align: right;
  padding-right: 20px;
}

.col-cat {
  flex: 1;
}

.col-actions {
  width: 140px;
  flex-shrink: 0;
  display: flex;
  gap: 6px;
  justify-content: flex-end;
}

.cat-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  background: rgba(59, 130, 246, 0.08);
  color: var(--pos-accent);
}

.act-edit, .act-del {
  padding: 5px 12px;
  border-radius: 6px;
  border: 1px solid var(--pos-border);
  background: transparent;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 100ms;
}

.act-edit {
  color: var(--pos-accent);
}
.act-edit:hover {
  background: var(--pos-accent);
  color: #fff;
  border-color: var(--pos-accent);
}

.act-del {
  color: var(--pos-red);
}
.act-del:hover {
  background: var(--pos-red);
  color: #fff;
  border-color: var(--pos-red);
}`],
})
export class PagePosSalesMenuComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) {}

    // ─── 카테고리 (DB에서 로드) ───
    public menuCategories: any[] = [];

    // ─── 메뉴 데이터 (DB에서 로드) ───
    public allMenuItems: any[] = [];

    // ─── 필터/폼 상태 ───
    public selectedCategory = '';
    public editingItem: any = null;
    public formName = '';
    public formPrice = '';
    public formCategory = '';
    public newCatName = '';
    public showAddCat = false;
    public searchText = '';

    get filteredItems() {
        let items = this.allMenuItems;
        if (this.selectedCategory) items = items.filter(m => m.category === this.selectedCategory);
        if (this.searchText.trim()) {
            const q = this.searchText.trim().toLowerCase();
            items = items.filter(m => m.name.toLowerCase().includes(q));
        }
        return items;
    }

    public async ngOnInit() {
        await this.service.init();
        await this.loadData();
        await this.service.render();
    }

    private async loadData() {
        let res = await wiz.call("load");
        if (res.code === 200) {
            this.menuCategories = res.data.categories;
            this.allMenuItems = res.data.menus;
        }
    }

    public goBack() {
        this.service.href('/pos/sales');
    }

    // ─── 카테고리 ───
    public async selectCategory(catId: string) {
        this.selectedCategory = this.selectedCategory === catId ? '' : catId;
        await this.service.render();
    }

    public getCategoryLabel(catId: string): string {
        const cat = this.menuCategories.find(c => c.id === catId);
        return cat ? cat.label : catId;
    }

    public getCategoryCount(catId: string): number {
        return this.allMenuItems.filter(m => m.category === catId).length;
    }

    public async toggleAddCat() {
        this.showAddCat = !this.showAddCat;
        this.newCatName = '';
        await this.service.render();
    }

    public async addCategory() {
        if (!this.newCatName.trim()) return;
        await wiz.call("add_category", { label: this.newCatName.trim() });
        await this.loadData();
        this.newCatName = '';
        this.showAddCat = false;
        await this.service.render();
    }

    public async deleteCategory(catId: string) {
        const count = this.allMenuItems.filter(m => m.category === catId).length;
        if (count > 0) return;
        await wiz.call("delete_category", { id: catId });
        await this.loadData();
        if (this.selectedCategory === catId) this.selectedCategory = '';
        await this.service.render();
    }

    // ─── 메뉴 CRUD ───
    public async startAdd() {
        this.editingItem = null;
        this.formName = '';
        this.formPrice = '';
        this.formCategory = this.selectedCategory || (this.menuCategories.length ? this.menuCategories[0].id : '');
        await this.service.render();
    }

    public async startEdit(item: any) {
        this.editingItem = item;
        this.formName = item.name;
        this.formPrice = String(item.price);
        this.formCategory = item.category;
        await this.service.render();
    }

    public async saveItem() {
        if (!this.formName.trim() || !this.formPrice.trim() || !this.formCategory) return;
        const price = parseInt(this.formPrice);
        if (isNaN(price) || price <= 0) return;

        await wiz.call("save_item", {
            id: this.editingItem ? this.editingItem.id : '',
            name: this.formName.trim(),
            price,
            category: this.formCategory,
            desc: '',
        });
        await this.loadData();
        this.editingItem = null;
        this.formName = '';
        this.formPrice = '';
        await this.service.render();
    }

    public async deleteItem(item: any) {
        await wiz.call("delete_item", { id: item.id });
        await this.loadData();
        if (this.editingItem?.id === item.id) this.editingItem = null;
        await this.service.render();
    }

    public async cancelEdit() {
        this.editingItem = null;
        this.formName = '';
        this.formPrice = '';
        await this.service.render();
    }

    public formatCurrency(v: number): string {
        return (v || 0).toLocaleString();
    }
}

export default PagePosSalesMenuComponent;